module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_29430059_L-79b25d340651cf1c4b5a647d73fb6684.jpg";